import  { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as SettingActions from "../redux/actions/SettingAction";
import { singletonHook } from 'react-singleton-hook';
import _ from 'lodash'

let  data = {bedStatuses:[], bedTypes:[], bedTags:[], defaultBedStatus:{}, defaultBedType:{}, tagService: []  }
const useBedServicesFn = ()=>{  
    const [filteredTags, setFilteredTags] = useState([]) 

    const GetDefaultBedStatus = (bedStatuses)=>{
        var index = _.findIndex(bedStatuses, (s)=> { return s.name === 'Ready'; });
        if(index >= 0)
            return bedStatuses[index]
        return null;

    }
    const GetDefaultBedTypes = (bedTypes)=>{       
        var index = _.findIndex(bedTypes, (s)=> { return s.isDefault });
        if(index >= 0)
            return bedTypes[index]
        return null;

    }
    const SearchTag = (event)=>{setTimeout(() => {
        let _filteredTags;
        if (!event.query.trim().length) {
            _filteredTags = [...data.bedTags];
        }
        else {
            _filteredTags = data.bedTags.filter((tag) => {
                return tag.name.toLowerCase().includes(event.query.toLowerCase());
            });
        }

        setFilteredTags(_filteredTags);
    }, 250)};
 
   

    data = useSelector((state) => {
        return {
                bedStatuses: state.setting.allBedStatus && state.setting.allBedStatus.length > 0 
                                ? state.setting.allBedStatus.filter((s)=>s.isActive) : state.setting.allBedStatus,
                bedTypes: state.setting.allBedTypes && state.setting.allBedTypes.length > 0 
                                ? state.setting.allBedTypes.filter((s)=>s.isActive) : state.setting.allBedTypes,
                bedTags: state.setting.allBedTags && state.setting.allBedTags.length > 0
                                ? state.setting.allBedTags.filter((s)=>s.isActive) : state.setting.allBedTags,
                defaultBedStatus: GetDefaultBedStatus(
                                    state.setting.allBedStatus && state.setting.allBedStatus.length > 0
                                        ? state.setting.allBedStatus.filter((s)=>s.isActive) : state.setting.allBedStatus),
                defaultBedType: GetDefaultBedTypes(state.setting.allBedTypes && state.setting.allBedTypes.length > 0 ?
                                                     state.setting.allBedTypes.filter((s)=>s.isActive) : state.setting.allBedTypes),
                tagService: [filteredTags, SearchTag]
        };
    });

    const dispatchSetup = useDispatch();
    const GetBedStatuses = useCallback(async () => {       
        var action = await SettingActions.GetBedStatus();
        dispatchSetup(action);       

    }, [dispatchSetup])

    const GetBedTypes = useCallback(async () => {       
        var action = await SettingActions.GetBedTypes();
        dispatchSetup(action);       

    }, [dispatchSetup])

    const GetBedTags = useCallback(async () => {       
        var action = await SettingActions.GetBedTags();
        dispatchSetup(action);       

    }, [dispatchSetup])
   

    useEffect(()=>{
        GetBedStatuses();
        GetBedTypes();  
        GetBedTags();     
    }, [GetBedStatuses, GetBedTypes, GetBedTags ])

    return data
}

export const useBedServices = singletonHook(data, useBedServicesFn);